import script from "./FallDetection.vue?vue&type=script&setup=true&lang=js"
export * from "./FallDetection.vue?vue&type=script&setup=true&lang=js"

import "./FallDetection.vue?vue&type=style&index=0&id=c37acee0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c37acee0"]])

export default __exports__